import { useSelector } from 'react-redux';
/**
 * Function that takes in the name of a value, loops through selectedRecords, and
 * returns an array of the values of the selected records
 *
 * @param {string} value attribute value to be aggregated from each of the selected records
 * @return {Array} array of values of the selected records
 */
export const aggregateValue = (value) => {
  const selectedRecords = useSelector((state) => state.mail.selectedRecords);
  const valueArray = [];

  Object.values(selectedRecords).forEach((record) => {
    valueArray.push(record[value]);
  });

  return valueArray;
};

export const sortRecordsAlphabetically = (items, objectsAndDisplayFields) => {
  return Object.values(items)?.sort((a, b) => {
    const aDisplayFields = objectsAndDisplayFields?.find((object) => object.apiName === a.type)?.displayFields;
    const bDisplayFields = objectsAndDisplayFields?.find((object) => object.apiName === b.type)?.displayFields;
    return a[aDisplayFields?.[0]?.apiName]?.toLowerCase() > b[bDisplayFields?.[0]?.apiName]?.toLowerCase() ? 1 : -1;
  });
};
